module.exports = __webpack_public_path__ + "media/images/help-center/help-center-icon-duels-cf029883e4a984a0c81c8934c841fc23.png";